var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#back-button_svg__clip0_2768_54535)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.799 18.874l-6.874-8.489L9.799 2.47",
    stroke: "#1C573D",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "back-button_svg__clip0_2768_54535"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(180 6.25 10.667)",
    d: "M0 0h12v21.333H0z"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAxMyAyMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzI3NjhfNTQ1MzUpIj4KPHBhdGggZD0iTTkuNzk4ODMgMTguODczN0wyLjkyNDYgMTAuMzg1Mkw5Ljc5ODgzIDIuNDY4ODEiIHN0cm9rZT0iIzFDNTczRCIgc3Ryb2tlLXdpZHRoPSIzIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF8yNzY4XzU0NTM1Ij4KPHJlY3Qgd2lkdGg9IjEyIiBoZWlnaHQ9IjIxLjMzMzMiIGZpbGw9IndoaXRlIiB0cmFuc2Zvcm09Im1hdHJpeCgtMSAwIDAgLTEgMTIuNSAyMS4zMzMzKSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=";
export { SvgBackButton as ReactComponent };